import React, { Fragment, useEffect, useRef, useState } from "react";
import { Form, Table } from "react-bootstrap";
import API from "../../services/axiosInstance";
import Pagination from "../common_modules/pagination";
import { Link, useNavigate } from "react-router-dom";
import { LuPenLine, LuTrash2, LuPlus } from "react-icons/lu";
import './role.css'
import { lastPage } from "../utils/helper";
import FilterBar from "../common_modules/filter";
import { FormLoader, useFormLoader } from "../common_modules/loader";
import { SearchIcon } from "../common_modules/commonIcons";

const RoleListing = () => {
    const [list, setList] = useState([]);
    const [paginationData, setpaginationData] = useState({});
    const [searchConfig, setSearchConfig] = useState();

    // global data
    const tableFields = [
        { label: "Id", value: "id", enableSorting: true, enableIcon: true },
        { label: "Name", value: "roleSetName", enableSorting: true, enableIcon: true },
        { label: "Belong To", value: "belongTo", enableSorting: false, enableIcon: false },
        { label: "Status", value: "status", enableSorting: false, enableIcon: false }
    ];

    // hooks
    const navigate = useNavigate();
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook

    const roleList = async (search, page, field = "", order = "") => {
        startLoading();
        try {
            const size = 100;
            const res = await API.get(`/tech/roles/set/list?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);
            const data = res?.data?.data?.content;
            if (res.status === 200 && data) {
                setList(data);
                // save pagination information
                let pagination = res.data.data;
                delete pagination.content; //  remove data
                setpaginationData(pagination);
            } else {
                setList([]);
                setpaginationData({});
            }
        } catch (error) { } finally {
            stopLoading();
        }
    }

    const nextPage = (nextPage) => {
        roleList("", nextPage, searchConfig?.orderField, searchConfig?.orderDir)
    }

    const updateRoleSet = (id) => {
        navigate(`/role/${id}`)
    }

    const activateDeactivate = async (data) => {
        startLoading();
        try {
            if (window.confirm(`Do you want ${data.status == 1 ? "Deactivate" : "Activate"} this user role !!! `)) {
                let response = await API.put(`/tech/roles/set/${data.id}/status`)
                if (response.status == 200) {
                    // alert(`${response.data.message} Successfully...`);
                    nextPage(lastPage(RoleListing.name));
                }
            }
        } catch (error) { } finally {
            stopLoading();
        }

    }

    const onChangeSearch = (params) => {
        setSearchConfig(params)
        roleList(params.keyword, 0, params.orderField, params.orderDir); // API call
    }

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="">
                <div className="breadCrumb gradient-bg">
                    <Link to={'/dashboard'}><span>Home</span></Link>
                    <span>Tech Admin</span>
                    <span>User Role</span>
                </div> 
                <h4 className="my-4">🧾 Role List</h4>
                {/* <div className="active-table-wrapper">
                    <div style={{
                        paddingBottom: "0.8rem",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}> */}
                <div className="filter row">
                    <Link
                        to={"/role/add"}
                        className="btn btn-primary btn-md addBtn"
                        style={{ whiteSpace: "nowrap" }}>
                        Create Role <LuPlus />
                    </Link>
                    <FilterBar fields={tableFields} onSearch={onChangeSearch} />
                </div>
                {/* </div> */}
                <div className="mt-0 table-wrapper mt-3">
                    <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
                        <thead>
                            <tr>
                                <th>☰</th>
                                {
                                    tableFields?.map((item, i) => (
                                        <th key={i}>
                                            {item.label}
                                            {item.enableIcon ? <SearchIcon className="ms-1" size={10} fill="white" /> : ""}
                                        </th>
                                    ))
                                }
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                list.length > 0 &&
                                list.map((item, index) => {
                                    return (
                                        <tr key={index} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 * index }} className="hover-glow">
                                            <td>{(paginationData.number * paginationData.size) + (index + 1)}</td>
                                            <td>{item.id}</td>
                                            <td><Link style={{
                                                textDecoration: "none"
                                            }} to={`/role/${item.id}`}>
                                                <span title={item?.roleSetName}>
                                                    {item?.roleSetName?.length > 20
                                                        ? item?.roleSetName.substring(0, 20) + "..."
                                                        : item?.roleSetName}
                                                </span>
                                            </Link></td>
                                            <td>{item.accountType}</td>
                                            <td style={{ textAlign: "center" }}>
                                                <span className={`badge ${item?.status === 1 ? "active" : "inactive"}`}>
                                                    {item?.status === 1 ? "Active" : "Inactive"}
                                                </span>
                                            </td>
                                            <td className="activePubAllBtns">
                                                <button onClick={(e) => updateRoleSet(item.id)}><LuPenLine /> Edit</button>
                                                <button onClick={(e) => activateDeactivate(item)}><LuTrash2 /> {item.status == 1 ? "Deactivate" : "Active"}</button>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </Table>
                    {
                        list.length <= 0 && <center>No Data Found !!!</center>
                    }
                </div>
                {/* pagination */}
                <Pagination
                    jumpPage={true}
                    count={true}
                    component={RoleListing.name}
                    size={"sm"}
                    paginationData={paginationData}
                    nextPage={nextPage} />
                {/* </div> */}
            </div>
        </FormLoader>
    );
};

export default RoleListing;
